import Signal from 'signals'

export default class SingletonClass {
    static _instance = new SingletonClass()

    constructor() {
        SingletonClass._instance = this
        this.signal = new Signal.Signal()
        //this.onResize = this.onResize.bind(this)
        this.direction = 'h'
        window.onresize = this.onResize.bind(this)
        //console.log('inited', window)
    }
    updateDirection(_dir){
        //_dir 'h' or 'v' or 'u'
        this.direction = _dir
        this.onResize()
    }
    onResize(){
        // console.log("resizeService:",window.innerWidth,window.innerHeight)
        // console.log(window)
        // console.log(window.outerWidth,window.outerWidth*9/16,window.outerHeight)
        this.signal.dispatch(window.innerWidth,window.innerHeight, this.direction)
        // this.signal.dispatch(window.outerWidth,window.outerWidth*9/16, this.direction)
    }
    add(_callback){
        this.signal.add(_callback)
        this.onResize()
    }
    remove(_callback){
        this.signal.remove(_callback)
    }
    static getInstance() {
        console.log("resizeService getInstance")
        return SingletonClass._instance
    }

}